export const getDecimalValue = (value, decimal) => {
  if (value?.includes('.')) {
    const [integerPart, decimalPart] = value.split('.');
    const truncatedDecimal = decimalPart.slice(0, decimal);
    return `${integerPart}.${truncatedDecimal}`;
  } else {
    return value;
  }
};
